import { Image, Text, View } from 'react-native';
import GlobalStyle from './style';
import transl from './translations/transl'

const cupsData = (cupType, icon,season,date,lang = 'es',props = []) => {
    let name
    let description
	let jugadorTrofeo
	let jugadorAge
    let elementImageIcon = <Image
                                style={{width:40,height:40}}
                                source={require('./img/cup4.png')}
                            />

    if (icon == 1) {
        elementImageIcon = <Image
                                style={{width:40,height:40}}
                                source={require('./img/cup1.png')}
                            />
    } else if (icon == 2) {
        elementImageIcon = <Image
                                style={{width:40,height:40}}
                                source={require('./img/cup2.png')}
                            />
    } else if (icon == 3) {
        elementImageIcon = <Image
                                style={{width:40,height:40}}
                                source={require('./img/cup3.png')}
                            />
    }

	if (!cupType.length && cupType >= 9 && props != []) {
		jugadorTrofeo = props[0]
		jugadorAge = props[1]

		elementImageIcon = <Image
			style={{ width: 40, height: 40 }}
			source={require('./img/trophy4.png')}
		/>
		if (icon == 1) {
			elementImageIcon = <Image
				style={{ width: 40, height: 40 }}
				source={require('./img/trophy1.png')}
			/>
		} else if (icon == 2) {
			elementImageIcon = <Image
				style={{ width: 40, height: 40 }}
				source={require('./img/trophy2.png')}
			/>
		} else if (icon == 3) {
			elementImageIcon = <Image
				style={{ width: 40, height: 40 }}
				source={require('./img/trophy3.png')}
			/>
		}
	}

    //esto es solo para el trofeo
    let positionOfTrophy = 'HallOfFame.oro'
    if(icon == 2) positionOfTrophy = 'HallOfFame.plata'
    else if(icon == 3) positionOfTrophy = 'HallOfFame.bronce'

    if (cupType.length == 2) {
        name = cupType[0];
        description = cupType[1];
        cupType = 0;
    } else if(cupType == 1){
        name = transl('HallOfFame.copaNacional',lang,[icon])
        description = transl('HallOfFame.copaNacionalD',lang,[icon])
    } else if (cupType == 2) {
        //copa perdedores
        name = transl('HallOfFame.copaPerdedores',lang,[icon])
        description = transl('HallOfFame.copaPerdedoresD',lang,[icon])
    } else if (cupType == 3) {
        //copa mundial
        name = transl('HallOfFame.copaMundial',lang,[icon])
        description = transl('HallOfFame.copaMundialD',lang,[icon])
    } else if (cupType == 4) {
        //copa continental
        name = transl('HallOfFame.copaContinental',lang,[icon])
        description = transl('HallOfFame.copaContinentalD',lang,[icon])
    } else if (cupType == 5) {
        //copa suprema
        name = transl('HallOfFame.copaSuprema',lang,[icon])
        description = transl('HallOfFame.copaSupremaD',lang,[icon])
    } else if (cupType == 6) {
        //triple corona
        name = transl('HallOfFame.tripleCorona',lang)
        description = transl('HallOfFame.tripleCoronaD',lang)
    } else if (cupType == 7) {
        //liga
        name = transl('HallOfFame.liga',lang,[icon])
        description =transl('HallOfFame.ligaD',lang,[icon])
    } else if (cupType == 8) {
        //copa universo
        name = transl('HallOfFame.copaUniverso',lang)
        description = transl('HallOfFame.copaUniversoD',lang)
    } else if (cupType == 9) {
        //trofeo quaffle (goles)
        name = transl('HallOfFame.trofeoQuaffle',lang,[transl(positionOfTrophy,lang)])
        description = transl('HallOfFame.trofeoQuaffleD',lang,[icon,season])
    } else if (cupType == 10) {
        //trofeo cazador (asistencias)
        name = transl('HallOfFame.trofeoCazador',lang,[transl(positionOfTrophy,lang)])
        description = transl('HallOfFame.trofeoCazadorD',lang,[icon,season])
    } else if (cupType == 11) {
        //trofeo reboteador (rebotes)
        name = transl('HallOfFame.trofeoReboteador',lang,[transl(positionOfTrophy,lang)])
        description = transl('HallOfFame.trofeoReboteadorD',lang,[icon,season])
    } else if (cupType == 12) {
        //trofeo zamora
        name = transl('HallOfFame.trofeoZamora',lang,[transl(positionOfTrophy,lang)])
        description = transl('HallOfFame.trofeoZamoraD',lang,[icon,season])
    } else if (cupType == 13) {
        //trofeo aros
        name = transl('HallOfFame.trofeoAros',lang,[transl(positionOfTrophy,lang)])
        description = transl('HallOfFame.trofeoArosD',lang,[icon,season])
    } else if (cupType == 14) {
        //trofeo buscador
        name = transl('HallOfFame.trofeoBuscador',lang,[transl(positionOfTrophy,lang)])
        description = transl('HallOfFame.trofeoBuscadorD',lang,[icon,season])
    } else if (cupType == 15) {
        //trofeo bate
        name = transl('HallOfFame.trofeoBate',lang,[transl(positionOfTrophy,lang)])
        description = transl('HallOfFame.trofeoBateD',lang,[icon,season])
    } else if (cupType == 16) {
        //trofeo escoba (regates y robados)
        name = transl('HallOfFame.trofeoEscoba',lang,[transl(positionOfTrophy,lang)])
        description = transl('HallOfFame.trofeoEscobaD',lang,[icon,season])
    } else if (cupType == 17) {
        //trofeo MVP (mismo que Kopa, pero sin edad)
        name = transl('HallOfFame.trofeoMVP',lang,[transl(positionOfTrophy,lang)])
        description = transl('HallOfFame.trofeoMVPD',lang,[icon,season])
    } else if (cupType == 18) {
        //trofeo Kopa (jugador menor de 21 con mas goles, rebotes y asistencias)
        name = transl('HallOfFame.trofeoKopa',lang,[transl(positionOfTrophy,lang)])
        description = transl('HallOfFame.trofeoKopaD',lang,[icon,season])
    } else if (cupType == 19) {
        //trofeo coronita de Quedepp
        name = transl('HallOfFame.trofeoCoronita',lang)
        description = transl('HallOfFame.trofeoCoronitaD',lang,[season])
    } else if (cupType == 20) {
        //trofeo coronita de Quedepp
        name = transl('HallOfFame.trofeoCentral',lang,[transl(positionOfTrophy,lang)])
        description = transl('HallOfFame.trofeoCentralD',lang,[icon,season])
    } else {
        //copa error
        name = "Copa Error"
        description = "¡Esta copa es un glitch!"
    }

    let cup =   <View key={season+icon+cupType} style={GlobalStyle.cardHalfScreen}>
                    <View style={GlobalStyle.centerHorizontally}>
                        {elementImageIcon}
                    </View>
                    <Text style={{textAlign:'center',marginBottom:25}}>{name}</Text>
                    <Text style={{textAlign:'center',marginBottom:10}}>{description}</Text>
					{elJugadorTrofeo(jugadorTrofeo,jugadorAge,lang)}
                    <Text style={{textAlign:'center',marginBottom:10}}>{transl('HallOfFame.temporada',lang,[season])}</Text>
                    <Text style={{textAlign:'center'}}>{transl('HallOfFame.fecha',lang,[date == 0 ? "N/A" : date.substring(0,10)])}</Text>
                </View>

    return cup;
}

function elJugadorTrofeo (jugadorTrofeo,jugadorAge,lang) {
	if (jugadorTrofeo && jugadorAge) return <Text style={{textAlign:'center',marginBottom:5}}>{transl('HallOfFame.jugadorTrofeo',lang,[jugadorTrofeo,jugadorAge])}</Text>
	return 
}

export default cupsData